import React from 'react'

export default function Footer(props) {
  const toggle = props.toggleSidebar ? '220px' : '10px'

  return (
    <footer className="footer ml-5" style={{marginLeft: `${toggle}`}}>
      <strong>
        Copyright © 2022 <a href="http://www.raffdev.com">raffdev.com</a>.
      </strong> All rights reserved.
      <div className="float-right d-none d-sm-inline-block">
        <b>Version</b> 1.0.0
      </div>
    </footer>
   
  );
}
